var _Circle, _Rect, _Rect2, _Rect3, _Path, _Path2, _Rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Circle, Rect, Path } from "react-native-svg";
var SvgPinEv = function SvgPinEv(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 39,
    fill: "none",
    viewBox: "2.5 1.5 39 39"
  }, props), _Circle || (_Circle = /*#__PURE__*/React.createElement(Circle, {
    cx: 22,
    cy: 21,
    r: 18,
    fill: "#FFFFFF",
    stroke: "#0D9488",
    strokeWidth: 2.5
  })), _Rect || (_Rect = /*#__PURE__*/React.createElement(Rect, {
    width: 13,
    height: 17.5,
    x: 13.5,
    y: 13.5,
    fill: "#0F766E",
    stroke: "#115E59",
    strokeWidth: 1.2,
    rx: 3.5
  })), _Rect2 || (_Rect2 = /*#__PURE__*/React.createElement(Rect, {
    width: 8,
    height: 4.5,
    x: 16,
    y: 16.5,
    fill: "#CCFBF1",
    stroke: "#0D9488",
    strokeWidth: 0.8,
    rx: 1
  })), _Rect3 || (_Rect3 = /*#__PURE__*/React.createElement(Rect, {
    width: 4,
    height: 1.8,
    x: 17.5,
    y: 18,
    fill: "#0D9488",
    rx: 0.5
  })), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "#5EEAD4",
    d: "m21 23-3.5 5H21l-1.2 4 5-5.2h-3l.7-3.8Z"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    stroke: "#0F766E",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.8,
    d: "M26.5 17h2c1.1 0 2 .9 2 2v5.5c0 1.1-.9 2-2 2h-1v-3"
  })), _Rect4 || (_Rect4 = /*#__PURE__*/React.createElement(Rect, {
    width: 3,
    height: 4.5,
    x: 27.5,
    y: 21,
    fill: "#14B8A6",
    stroke: "#0D9488",
    strokeWidth: 1,
    rx: 1
  })));
};
export default SvgPinEv;